/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-10.
 * This service is only for testing
 */
import { apiUrl } from '../app.config';
import { serializeParams } from '../common/helpers';
import request from './request';

export const getCustomers = (params = {}) => {
    const url = 'customers';
    return request().get(`${apiUrl}${url}${serializeParams(params)}`).then(response => {
        return Promise.resolve(response.data);
    });
};



// WEBPACK FOOTER //
// ./services/test.js